import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import HelpIcon from "@mui/icons-material/Help";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import InfoIcon from '@mui/icons-material/Info';
import { t } from "i18next";

type QuestionAndAnswerProps = {
  question: string;
  answer: string;
};

type QuestionSectionProps = {
  name: string;
  qa: any;
};

export function QuestionSection(props: QuestionSectionProps) {
  return (
    <Accordion disableGutters>
      <AccordionSummary
        id={props.name}
        expandIcon={<ExpandMoreIcon />}
        style={{ fontSize: "22px", fontWeight: 500 }}
      >
        <HelpIcon
          sx={{ marginRight: "10px" }}
          color="info"
          style={{ width: "32px", height: "32px" }}
        />
        {t("tutorial:" + props.name)}
      </AccordionSummary>
      <AccordionDetails>{props.qa}</AccordionDetails>
    </Accordion>
  );
}

export function QuestionAndAnswer(props: QuestionAndAnswerProps) {
  return (
    <ListItem>
      <ListItemAvatar>
        <Avatar
          style={{
            backgroundColor: "transparent",
            width: "32px",
            height: "32px",
          }}
        >
          <InfoIcon color="disabled" style={{ width: "32px", height: "32px" }} />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={"Q: " + t("tutorial:" + props.question)}
        primaryTypographyProps={{ fontWeight: 500 }}
        secondary={"A: " + t("tutorial:" + props.answer)}
      ></ListItemText>
    </ListItem>
  );
}

const questionSections = [
  {
    name: "about_us",
    qas: [
      {
        question: "what_does_trendz_do",
        answer: "what_does_trendz_do_answer",
      },
    ],
  },
  {
    name: "account",
    qas: [
      {
        question: "how_to_register",
        answer: "how_to_register_answer",
      },
      {
        question: "about_your_information",
        answer: "about_your_information_answer",
      },
    ],
  },
  {
    name: "plan",
    qas: [
      {
        question: "what_plans_does_trendz_have",
        answer: "what_plans_does_trendz_have_answer",
      },
      {
        question: "what_plans_will_trendz_have",
        answer: "what_plans_will_trendz_have_answer"
      }
    ],
  },
  {
    name: "error_codes",
    qas: [],
  },
];

export function TutorialPage() {
  const { t } = useTranslation(["common", "tutorial"]);

  const qaSections = questionSections.map((section) => {
    var qaList = (section.qas as any[]).map((qa) => {
      return <QuestionAndAnswer question={qa.question} answer={qa.answer} />;
    });
    return <QuestionSection qa={qaList} name={section.name}></QuestionSection>;
  });

  //   const qaList = questionsAndAnswers.map((qa) => {
  //     return <QuestionAndAnswer question={qa.question} answer={qa.answer} />;
  //   });
  return (
    <Grid xs={12} container>
      <Grid xs={0.75}></Grid>
      <Grid
        xs={10.5}
        className="white grid-border slide-from-top"
        paddingTop={1}
        marginTop={2}
      >
        <Typography variant="h4" fontWeight={600}>
          {t("tutorial:faq") + " (FAQs)"}
        </Typography>
        {qaSections}
      </Grid>
      <Grid xs={0.75}></Grid>
    </Grid>
  );
}
